import React, { useState, useEffect, useContext } from 'react';
import style from '../../../css/Product.module.css';
import { fetchAllProducts1 } from "../../../components/Service/ProductService.js";
import Server from '../Server/Server.js';
import PackagesCSHP from '../CSHP/PackagesCSHP.js';
import Operating from '../Server/Operating.js';
import Cookies from 'js-cookie';
import InvoiceCSHP from '../CSHP/BillCSHP.js';
import { useRegion } from "../../../Context/RegionsContext.js";
import { BillContext } from '../../Bill/BillContext.js';
import deburr from 'lodash/deburr';
import Backup from '../CSHP/BackupCSHP.js';

import useLanguage from '../../../Hooks/useLanguage.js';
import { useTranslation } from 'react-i18next';
import LoadingSpinner from '../../../css/Loading.js';
const ParentPanel = React.memo(({ selectedLanguage }) => {
    const [server, setServer] = useState([]);
    const [regions, setregions] = useState([]);
    const { selectedRegion } = useRegion(); // Sử dụng RegionContext
    const [packages, setSelectedPackage] = useState([]);//1
    const [serverchose, setserverchose] = useState([]);//1
    const [circleChose, setcircleChose] = useState([]);//1
    const [pricebackup, setpricebackup] = useState(null);
    const [selectedChildSystem, setselectedChildSystem] = useState(null);
    const [selectednameversion, setselectednameversion] = useState(null);
    const [selectedFeatures, setSelectedFeatures] = useState([]);
    const [cookieData, setCookieData] = useState({});

    const [hostname, sethostname] = useState(null);
    const [error, setError] = useState(false); // Trạng thái lỗi

    const handleChildError = (error) => {
        setError(error); // Cập nhật lỗi
    };

    // console.log("selectedRegion", selectedRegion)

    //Danh Sách Tuyền hóa đơn


    const [pricekm, setpriceKM] = useState(0);

    const [isChecked, setIsChecked] = useState(false);

    const [backup, setbackup] = useState("");
    useLanguage();

    const { t } = useTranslation();

    const { totalAmount, calculateTotal, baseAmount, taxAmount, postdiscount, backupPrice } = useContext(BillContext); // Sử dụng BillContext

    // const saveToCookies = (key, id) => {
    //     Cookies.set(key, id, {expires: 7 });
    // };
    const handleClickTypeBackup = (type) => {
        setbackup(type);
    }


    // console.log("backupne", backup)
    useEffect(() => {
        // if (packages) {
        //     setcircleChose({
        //         cycle: "monthly",
        //         price: packages.monthly,
        //         months: 1,
        //     });
        // }
        // console.log("circleChose", circleChose)
    }, [packages]);
    // console.log("packages", packages)

    // useEffect(() => {
    //     if (packages && circleChose) {
    //         calculateTotal(packages, circleChose, pricebackup, pricekm, backup);
    //     }
    // }, [packages, circleChose, pricebackup, pricekm, calculateTotal, backup]);


    // console.log("selectedRegion", selectedRegion.slug)
    // console.log("circleChose", circleChose)


    useEffect(() => {
        if (packages && circleChose && pricebackup) {
            calculateTotal(packages, circleChose, pricebackup, pricekm);
        }
    }, [packages, circleChose, pricebackup, pricekm, calculateTotal, selectedRegion]);
    const [loading, setLoading] = useState(true);



    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const response = await fetchAllProducts1(selectedRegion.slug);
                const data = response?.systems || [];
                setServer(data || []);
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        };

        if (selectedRegion) {
            fetchData();
        }
    }, [selectedRegion]);



    // console.log("server", server)



    // console.log("regions", regions)
    // useEffect(() => {
    //     updateURLFromCookies();

    //     const params = new URLSearchParams(window.location.search);

    //     const serverId = params.get("server");
    //     const packageId = params.get("package");
    //     const cycle = params.get("cycle");
    //     // const region = params.get("region");
    //     const discount = params.get("discount");
    //     const backupType = params.get("backup");
    //     const images = params.get("images");

    //     if (serverId) setserverchose({ id: serverId });
    //     if (packageId) setSelectedPackage({ id: packageId });
    //     if (cycle) setcircleChose({ cycle });
    //     // if (region) setregions(region);
    //     if (discount) setpriceKM(parseFloat(discount));
    //     if (backupType) setbackup(backupType);
    //     if (images) setselectedChildSystem(images);
    // }, []);
    // const updateURL = (selectedImageId) => {
    //     const params = new URLSearchParams(window.location.search);

    //     if (selectedRegion && selectedRegion.slug) {
    //         params.set("region", selectedRegion.slug);
    //     } else {
    //         window.history.replaceState(null, "", window.location.pathname);
    //         return;
    //     }

    //     if (serverchose.id) params.set("server", serverchose.id);
    //     if (packages.id) params.set("package", packages.id);
    //     if (circleChose.cycle) params.set("cycle", circleChose.cycle);
    //     if (pricekm) params.set("discount", pricekm);
    //     if (backup) params.set("backup", backup);
    //     if (selectedImageId) params.set("images", selectedImageId);

    //     window.history.replaceState(null, "", `?${params.toString()}`);
    // };


    const updateURLFromCookies = () => {
        const params = new URLSearchParams(window.location.search);
        const storageString = localStorage.getItem("redirectURLPublic"); // Lấy dữ liệu từ localStorage

        if (storageString) {
            const cookieParams = new URLSearchParams(storageString);
            let cookieObject = {};

            for (const [key, value] of cookieParams) {
                params.set(key, value);
                cookieObject[key] = value; // Lưu vào object
            }

            // Cập nhật URL mà không reload trang
            window.history.replaceState(null, "", `?${params.toString()}`);
            setCookieData(cookieObject); // Cập nhật state
        } else {
            console.log("No redirectURLPublic cookie found.");
        }
    };
    useEffect(() => {
        updateURLFromCookies();

        const params = new URLSearchParams(window.location.search);

        const serverId = params.get("server");
        const packageId = params.get("package");
        const cycle = params.get("cycle");
        // const region = params.get("region");
        const discount = params.get("discount");
        const backupType = params.get("backup");
        const images = params.get("images");

        if (serverId) setserverchose({ id: serverId });
        if (packageId) setSelectedPackage({ id: packageId });
        if (cycle) setcircleChose({ cycle });
        // if (region) setregions(region);
        if (discount) setpriceKM(parseFloat(discount));
        if (backupType) setbackup(backupType);
        if (images) setselectedChildSystem(images);
    }, []);
    const updateURL = () => {
        const params = new URLSearchParams(window.location.search);

        if (selectedRegion && selectedRegion.slug) {
            params.set("region", selectedRegion.slug);
        } else {
            window.history.replaceState(null, "", window.location.pathname);
            return;
        }

        if (serverchose.id) params.set("server", serverchose.id);
        if (packages.id) params.set("package", packages.id);
        if (circleChose.cycle) params.set("cycle", circleChose.cycle);
        if (pricekm) params.set("discount", pricekm);
        if (backup) params.set("backup", backup);
        if (selectedChildSystem) params.set("images", selectedChildSystem);

        const newUrl = `?${params.toString()}`;

        window.history.replaceState(null, "", newUrl);

        return newUrl; // Trả về URL vừa được cập nhật
    };
    useEffect(() => {
        const timer = setTimeout(() => {
            const newUrl = updateURL();

            if (newUrl) {
                localStorage.setItem('redirectURLPublic', newUrl);
                // Cookies.set("redirectURLPublic", newUrl, { expires: 7 });
                console.log("Saved to cookie:", newUrl);
            }
        }, 300);

        return () => clearTimeout(timer);
    }, [serverchose, packages, circleChose, pricekm, backup, selectedChildSystem, selectedRegion]);
    // useEffect(() => {
    //     const timer = setTimeout(() => {
    //         updateURLFromCookies(); // Cập nhật URL từ cookies
    //         console.log("cookieData", cookieData)
    //         updateURL();
    //         // Reload trang sau khi URL đã được cập nhật
    //     }, 300);

    //     return () => clearTimeout(timer);
    // }, [serverchose, packages, circleChose, pricekm, backup]);





    const handleSelectedPackage = (pkg) => {
        setSelectedPackage(pkg);

    };

    const handleCycleChange = (cycle) => {
        setcircleChose(cycle);
    };
    const handleonPriceBackup = (price) => {
        setpricebackup(price);
    }

    // console.log("pricebackup", pricebackup)

    // useEffect(() => {
    //     console.log("pricebackup", pricebackup)

    // }, [pricebackup]
    // )

    const handleSelectedServer = (server) => {
        setserverchose(server);
    }

    const handleSelectedChildSystem = ({ filteredIds, type }) => {
        if (filteredIds && filteredIds.length > 0) {
            const selectedImageId = filteredIds[0];
            setselectedChildSystem(selectedImageId);
            updateURL(selectedImageId);
        }
        console.log("filteredIds", filteredIds)

    };

    const handleselectNameVersionSystem = (child) => {
        setselectednameversion(child);

    }

    const handleSelectedFeatures = (features) => {
        setSelectedFeatures(features);
    };
    const handleXuLyGiaKhuyenMai = (priceKM) => {
        setpriceKM(priceKM)
    }
    const handleStatusChange = (status) => {
        setIsChecked(status); // Nhận trạng thái từ con
    };

    // console.log("isCheckedP", isChecked)

    const handleHostnameChange = (e) => {
        const rawValue = e.target.value;
        const normalizedValue = rawValue.normalize("NFD").replace(/[\u0300-\u036f]/g, '');
        const sanitizedValue = normalizedValue.replace(/[^a-zA-Z0-9\-\._]/g, '');
        if (sanitizedValue === '') {
            console.error('Không được để trống!');
            setError('Hostname không được để trống!');
        } else {
            setError('');
        }
        sethostname(sanitizedValue);
    };

    // useEffect(() => {
    //     saveToCookies("selectedRegion", selectedRegion?.id);
    // }, [selectedRegion]);



    useEffect(() => {
    }, [serverchose]);

    // useEffect(() => {
    //     saveToCookies("Package", packages?.id);
    // }, [packages]);




    // Cookies.set("Region", selectedRegion)
    if (loading) {
        return (
            <LoadingSpinner></LoadingSpinner>
        );
    }

    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12 col-xl-9 col-lg-9 mx-auto mb-4  " style={{
                        width: "78.16667%", // 9.5/12 * 100%
                    }}>
                        <div className="row">
                            <div className="d-flex align-items-center mb-3" style={{ position: "relative", margin: "0", padding: "0px" }}>
                                <div
                                    style={{
                                        width: "10px",
                                        height: "100%",
                                        backgroundColor: "#007bff",
                                        marginRight: "10px",
                                    }}
                                ></div>
                                <h5 className="m-0">{t("Deploy a Server")} CSHP</h5>
                            </div>
                            <div className="col-12 mx-1">
                                <div className={style.section}>
                                    <div className={style.tiltleframe}>
                                        <h5>{t("Choose Type")} <span style={{ color: "red", position: "relative", top: "-5px", fontSize: "15px" }}>*</span></h5>
                                    </div>
                                    <Server
                                        server={server} onSelectedServer={handleSelectedServer}

                                    />
                                </div>
                                <div >
                                    {/* <div className={style.tiltleframe}>
                                        <h5>{t("Choose Image")} <span style={{ color: "red", position: "relative", top: "-5px", fontSize: "15px" }}>*</span>
                                        </h5>
                                    </div> */}
                                    <Operating serverchose={serverchose} onSelectedChildSystem={handleSelectedChildSystem} onselectNameVersionSystem={handleselectNameVersionSystem} cookieData={cookieData} />
                                </div>
                                <div className={style.section}>
                                    <div className={style.tiltleframe}>
                                        <h5>{t("Choose Plan")}                                        <span style={{ color: "red", position: "relative", top: "-5px", fontSize: "15px" }}>*</span></h5>
                                    </div>
                                    <PackagesCSHP circleChose={circleChose} serverchose={serverchose} onSelectedPackage={handleSelectedPackage} selectedChildSystem={selectedChildSystem} cookieData={cookieData}
                                    />
                                </div>
                                <div
                                    style={{
                                        color: error ? 'red' : 'black',
                                        fontWeight: 'bold',
                                        borderRadius: '5px',
                                        margin: 0,
                                        padding: 0
                                    }}
                                    className={style.section}
                                >


                                </div>
                                {/* 

                                <div className={style.section}>
                                    <div className={style.tiltleframe}>
                                        <h5>Choose Cycle <span style={{ color: "red", position: "relative", top: "-5px", fontSize: "15px" }}>*</span></h5>
                                    </div>
                                    <Circle selectedPackage={packages} onCycleChange={handleCycleChange} />
                                </div> */}
                                <div className={style.tiltleframe}>
                                    <h5>{t("Hostname")} <span style={{ color: "red", position: "relative", top: "-5px", fontSize: "15px" }}>*</span>
                                    </h5>

                                </div>
                                <div className="form-group">
                                    <label
                                        htmlFor="domainHostingName"
                                        style={{
                                            fontSize: '14px',
                                            fontWeight: 'bold',
                                            marginBottom: '5px',
                                        }}
                                    >
                                    </label>
                                    <input
                                        type="text"
                                        id="domainHostingName"
                                        className="form-control"
                                        placeholder={t("Please enter hostname")}
                                        style={{
                                            border: error ? '1px solid red' : '1px solid #ccc', // Khung đỏ nếu lỗi
                                            borderRadius: '5px',
                                            width: '100%',
                                            boxSizing: 'border-box',
                                        }}
                                        value={hostname}
                                        onChange={handleHostnameChange}
                                    />
                                    {/* {error && (
                                            <small style={{ color: 'red', fontWeight: 'bold' }}>
                                                Hostname không được để trống!
                                            </small>
                                        )} */}
                                </div>
                                <div className={style.section}>
                                    <div className={style.tiltleframe}>
                                        <h5>{t("Backup")}
                                        </h5>
                                    </div>
                                    {/* <Backups onSelectedfeatures={handleSelectedFeatures} pricepermonth={pricepermonth} priceAdd={priceAdd} /> */}

                                    <Backup packages={packages} onPriceBackup={handleonPriceBackup}
                                    ></Backup>
                                </div>
                                <div className={style.section}>
                                    <div className={style.tiltleframe}>
                                        <h5>{t("Pre-installed apps")}
                                        </h5>
                                    </div>
                                    <div className={style.category}>
                                        <div className={style.label}>WebServer</div>
                                        <div className={style.options}>
                                            <button className={`${style.optionBtn} ${style.active}`}>
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    aria-hidden="true"
                                                    width={15.84}
                                                    height={18}
                                                    viewBox="0 0 256 291"
                                                    className="mr-1 iconify iconify--logos"
                                                >
                                                    <path
                                                        fill="#009639"
                                                        d="M2.054 218.187c1.32 2.347 3.227 4.108 5.575 5.428l112.962 65.137c4.695 2.787 10.416 2.787 14.964 0l112.963-65.137c4.695-2.64 7.482-7.629 7.482-13.057V80.284c0-5.428-2.787-10.416-7.482-13.056L135.555 2.09c-4.694-2.788-10.416-2.788-14.964 0L7.63 67.228C2.787 69.868 0 74.856 0 80.284v130.42c0 2.642.587 5.136 2.054 7.483"
                                                    />
                                                    <path
                                                        fill="#FFF"
                                                        d="M91.837 195.154a14.463 14.463 0 01-14.524 14.524 14.463 14.463 0 01-14.523-14.524V95.542c0-7.776 6.895-14.084 16.43-14.084 6.896 0 14.965 2.787 19.806 8.802l4.4 5.282 60.737 72.618V95.835a14.463 14.463 0 0114.524-14.524 14.463 14.463 0 0114.523 14.524v99.613c0 7.775-6.895 14.083-16.43 14.083-6.896 0-14.965-2.787-19.806-8.802l-65.137-77.754z"
                                                    />
                                                </svg> Nginx
                                            </button>
                                            {/* <button className={style.optionBtn}>
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    aria-hidden="true"
                                                    width={18}
                                                    height={18}
                                                    viewBox="50 50 200 200"
                                                    className="mr-1 iconify iconify--custom"
                                                >
                                                    <path
                                                        d="M216.46 101.33a1.402 1.402 0 00-1.014-.561 1.396 1.396 0 00-1.086.399l-6.555 6.532a1.4 1.4 0 00-.152 1.787c8.453 11.95 12.933 25.954 12.933 40.514 0 38.906-31.709 70.57-70.685 70.57-2.703 0-5.517-.197-8.838-.609-.206-.03-1.092-.166-1.649-.256a73.813 73.813 0 01-7.844-1.623s-.395-.1-.479-.129a.274.274 0 01-.072-.023 69.998 69.998 0 01-9.145-3.262 66.653 66.653 0 01-8.712-4.581l85.846-45.399c2.728-1.443 4.389-3.986 4.438-6.801.057-2.811-1.5-5.418-4.176-6.967l-29.482-17.062 43.625-43.626c3.137-3.13 2.887-5.947 2.133-7.744-.902-2.221-3.245-3.773-5.693-3.773-1.316 0-2.539.353-4.086 1.182l-104.73 55.384c-2.741 1.443-4.407 3.994-4.458 6.833-.041 2.823 1.538 5.419 4.217 6.943l29.535 16.993-31.919 31.91a73.659 73.659 0 01-5.002-6.019c-6.52-8.793-10.806-18.51-12.732-28.875a5.252 5.252 0 01-.07-.447c-.006-.028-.008-.057-.015-.094l-.043-.215c-.29-1.707-.608-3.693-.796-5.672a18.93 18.93 0 01-.068-1.412c0-.012 0-.02-.006-.032l-.102-1.796c-.069-1.014-.144-2.162-.144-3.332 0-4.821.479-9.611 1.432-14.232a66.049 66.049 0 011.632-6.339 1.25 1.25 0 00.052-.2c.007-.038.017-.11.033-.16l.001-.007c9.233-29.73 36.332-49.706 67.431-49.706 4.276 0 8.663.495 13.805 1.562l.624.132c1.611.338 3.408.802 5.48 1.408 1.102.321 2.205.719 3.178 1.067l.918.329c.842.291 1.727.598 2.527.931.012.003.023.013.041.016.114.045.213.092.332.144l.045.023c.39.181.845.169 1.228-.037l10.327-5.467c.451-.237.733-.709.738-1.226 0-.513-.287-.98-.738-1.22-11.828-6.282-25.147-9.6-38.504-9.6-45.502 0-82.516 37.012-82.516 82.515 0 18.435 6.054 35.94 17.509 50.62a84.81 84.81 0 004.968 5.775l-3.366 3.37c-3.122 3.102-2.892 5.911-2.145 7.72.924 2.229 3.273 3.785 5.714 3.785 1.29 0 2.545-.361 4.071-1.17l7.001-3.715a83.83 83.83 0 006.929 4.602c12.75 7.535 27.214 11.521 41.835 11.521 45.488 0 82.5-37.014 82.5-82.511-.001-17.587-5.546-34.417-16.054-48.667z"
                                                        fill="#75D1DF"
                                                    />
                                                    <path
                                                        d="M90.169 216.28c-.408 0-.948-.336-1.096-.688-.116-.282-.359-.874 1.049-2.272l45.011-45.002a3.635 3.635 0 001.028-3.029 3.627 3.627 0 00-1.778-2.649l-31.101-17.896c-1.089-.625-1.73-1.579-1.715-2.552.016-.967.688-1.896 1.796-2.481l104.73-55.388c.998-.53 1.46-.599 1.76-.599.412 0 .914.318 1.059.664.139.327.385.91-1.03 2.319l-44.915 44.915a3.618 3.618 0 00-1.027 3.018 3.628 3.628 0 001.768 2.652l31.05 17.966c1.07.62 1.702 1.567 1.679 2.53-.017.984-.684 1.916-1.777 2.502L91.91 215.694c-.989.53-1.449.586-1.74.586z"
                                                        fill="#FFD633"
                                                    />
                                                </svg>     OpenLiteSpeed
                                            </button>
                                            <button className={style.optionBtn}>
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    aria-hidden="true"
                                                    width={9}
                                                    height={18}
                                                    viewBox="0 0 256 512"
                                                    className="mr-1 iconify iconify--logos"
                                                >
                                                    <defs>
                                                        <linearGradient
                                                            id="a"
                                                            x1="16.363%"
                                                            x2="159.99%"
                                                            y1="63.905%"
                                                            y2="20.213%"
                                                        >
                                                            <stop offset="0%" stopColor="#F69923" />
                                                            <stop offset="31.23%" stopColor="#F79A23" />
                                                            <stop offset="83.83%" stopColor="#E97826" />
                                                        </linearGradient>
                                                        <linearGradient
                                                            id="b"
                                                            x1="-217.651%"
                                                            x2="74.743%"
                                                            y1="394.672%"
                                                            y2="13.846%"
                                                        >
                                                            <stop offset="32.33%" stopColor="#9E2064" />
                                                            <stop offset="63.02%" stopColor="#C92037" />
                                                            <stop offset="75.14%" stopColor="#CD2335" />
                                                            <stop offset="100%" stopColor="#E97826" />
                                                        </linearGradient>
                                                        <linearGradient
                                                            id="c"
                                                            x1="-80.044%"
                                                            x2="146.24%"
                                                            y1="170.418%"
                                                            y2="-44.299%"
                                                        >
                                                            <stop offset="32.33%" stopColor="#9E2064" />
                                                            <stop offset="63.02%" stopColor="#C92037" />
                                                            <stop offset="75.14%" stopColor="#CD2335" />
                                                            <stop offset="100%" stopColor="#E97826" />
                                                        </linearGradient>
                                                        <linearGradient
                                                            id="d"
                                                            x1="-18.316%"
                                                            x2="165.002%"
                                                            y1="77.36%"
                                                            y2="-41.416%"
                                                        >
                                                            <stop offset="0%" stopColor="#282662" />
                                                            <stop offset="9.548%" stopColor="#662E8D" />
                                                            <stop offset="78.82%" stopColor="#9F2064" />
                                                            <stop offset="94.87%" stopColor="#CD2032" />
                                                        </linearGradient>
                                                        <linearGradient
                                                            id="e"
                                                            x1="-129.783%"
                                                            x2="66.456%"
                                                            y1="463.715%"
                                                            y2="17.19%"
                                                        >
                                                            <stop offset="32.33%" stopColor="#9E2064" />
                                                            <stop offset="63.02%" stopColor="#C92037" />
                                                            <stop offset="75.14%" stopColor="#CD2335" />
                                                            <stop offset="100%" stopColor="#E97826" />
                                                        </linearGradient>
                                                        <linearGradient
                                                            id="f"
                                                            x1="-34.88%"
                                                            x2="110.599%"
                                                            y1="187.706%"
                                                            y2="-51.1%"
                                                        >
                                                            <stop offset="32.33%" stopColor="#9E2064" />
                                                            <stop offset="63.02%" stopColor="#C92037" />
                                                            <stop offset="75.14%" stopColor="#CD2335" />
                                                            <stop offset="100%" stopColor="#E97826" />
                                                        </linearGradient>
                                                        <linearGradient
                                                            id="g"
                                                            x1="-20.619%"
                                                            x2="125.26%"
                                                            y1="192.564%"
                                                            y2="-136.906%"
                                                        >
                                                            <stop offset="0%" stopColor="#282662" />
                                                            <stop offset="9.548%" stopColor="#662E8D" />
                                                            <stop offset="78.82%" stopColor="#9F2064" />
                                                            <stop offset="94.87%" stopColor="#CD2032" />
                                                        </linearGradient>
                                                    </defs>
                                                    <path
                                                        fill="url(#a)"
                                                        d="M218.048 2.889c-7.969 4.681-21.316 18.129-37.254 37.553v1.195l13.945 25.8.698.498c10.26-14.643 20.619-27.891 31.178-39.147.797-.897 1.195-1.295 1.195-1.295-.398.398-.797.896-1.195 1.295-3.387 3.785-13.747 15.738-29.286 39.645l1.793.398s36.358-3.586 53.89-6.574l.996-.897c5.578-31.278-5.479-45.621-5.479-45.621s-13.945-22.513-30.48-12.85"
                                                    />
                                                    <path
                                                        fill="url(#b)"
                                                        d="M152.405 139.156c4.482-8.267 8.965-16.435 13.447-24.305 4.682-8.168 9.463-16.137 14.344-23.807.299-.398.598-.896.797-1.394a548 548 0 0114.444-21.715l-14.643-27.593c-1.096 1.295-2.192 2.69-3.287 4.084-4.184 5.28-8.567 10.858-13.05 16.835a769 769 0 00-15.539 21.516 829 829 0 00-14.742 21.814c-4.184 6.475-8.467 13.05-12.65 19.923-.2.298-.3.498-.499.797v1.095l18.229 36.159.797.299c4.084-7.97 8.168-15.938 12.352-23.708"
                                                    />
                                                    <path
                                                        fill="url(#c)"
                                                        d="M73.015 316.165c3.287-8.567 6.773-17.233 10.26-25.998 3.386-8.368 6.773-16.835 10.36-25.302 3.486-8.467 7.171-16.933 10.857-25.5 3.785-8.666 7.57-17.332 11.455-25.899 3.885-8.467 7.77-16.934 11.754-25.301a377 377 0 014.383-9.065c2.49-5.18 5.08-10.36 7.57-15.44.1-.298.3-.497.399-.796l-19.026-37.553-.896 1.494c-4.383 7.271-8.866 14.642-13.149 22.213a873 873 0 00-12.85 23.309c-3.586 6.674-6.972 13.348-10.36 20.121-.697 1.395-1.294 2.69-1.991 4.084a514 514 0 00-11.256 24.704q-5.678 13.447-10.16 25.7c-1.993 5.378-3.686 10.459-5.38 15.44a609 609 0 00-3.785 12.65 360 360 0 00-7.272 29.783l.3 1.196 18.228 36.258.598.299c2.49-6.774 5.08-13.547 7.77-20.52.697-1.992 1.494-3.885 2.19-5.877"
                                                    />
                                                    <path
                                                        fill="url(#d)"
                                                        d="M43.73 306.104c-2.391 12.053-4.085 24.106-4.981 36.06 0 .398-.1.796-.1 1.294-5.977-9.562-21.914-18.826-21.914-18.826 11.455 16.535 20.121 32.971 21.416 49.108-6.076 1.295-14.444-.598-24.205-4.084 10.06 9.264 17.63 11.854 20.619 12.551-9.264.598-18.926 6.973-28.688 14.244 14.244-5.777 25.7-8.068 33.967-6.275C26.795 427.132 13.746 467.972.598 511.203c3.984-1.195 6.375-3.885 7.77-7.57 2.29-7.87 17.83-59.269 42.035-126.905.697-1.892 1.395-3.884 2.092-5.777.2-.498.398-1.096.598-1.594 2.59-7.072 5.18-14.344 7.968-21.715.598-1.693 1.295-3.387 1.893-5.08v-.1L43.928 304.81c0 .498-.1.897-.199 1.295"
                                                    />
                                                    <path
                                                        fill="url(#e)"
                                                        d="M197.33 68.532c-4.284 6.575-8.966 14.045-14.046 22.512-.299.399-.498.897-.797 1.295a836 836 0 00-13.846 24.206 1001 1001 0 00-13.148 24.604 924 924 0 00-12.253 24.404l.897.399 46.319-4.98 1.096-.798c14.045-6.474 20.32-12.351 26.397-20.818a230 230 0 004.88-7.272c4.981-7.77 9.862-16.237 14.145-24.703 4.184-8.169 7.87-16.337 10.758-23.608 1.793-4.682 3.287-8.965 4.284-12.75q1.344-5.08 2.091-9.563c-18.726 3.287-41.737 6.375-56.778 7.072"
                                                    />
                                                    <path
                                                        fill="url(#f)"
                                                        d="M141.447 169.438c-1.593 3.387-3.287 6.873-4.98 10.36-1.793 3.785-3.686 7.77-5.479 11.754-.896 1.992-1.892 4.084-2.789 6.076-2.888 6.176-5.678 12.551-8.666 19.125a1713 1713 0 00-10.957 25.202c-3.586 8.367-7.172 16.934-10.758 25.899a1436 1436 0 00-10.46 26.197c-3.187 8.069-6.374 16.237-9.562 24.803-.2.399-.299.797-.498 1.196-3.187 8.467-6.296 17.08-9.584 25.945-.1.2-.277.718-.377.917l.688.153 13.855-1.49.782-.324c-.299-.1-.483-.498-.782-.597 18.329-2.291 42.733-16.038 58.571-32.972 7.272-7.77 13.846-17.033 20.022-27.79 4.582-8.07 8.766-16.935 12.85-26.796 3.586-8.567 6.973-17.93 10.26-27.99-4.184 2.19-9.065 3.884-14.344 4.98-.897.199-1.893.398-2.889.597-.996.2-1.992.3-2.889.498 17.134-6.574 27.892-19.324 35.76-34.863-4.482 3.087-11.853 7.072-20.619 9.064-1.195.299-2.39.498-3.685.697-.3 0-.598.1-.897.1 5.977-2.49 10.957-5.28 15.34-8.567.897-.697 1.793-1.394 2.69-2.191 1.295-1.195 2.59-2.39 3.785-3.586.797-.797 1.494-1.594 2.291-2.49a56 56 0 004.781-6.575c.498-.697.897-1.494 1.395-2.191.598-1.096 1.096-2.191 1.594-3.287 2.39-4.781 4.283-9.065 5.777-12.85.797-1.893 1.395-3.586 1.992-5.28.2-.597.399-1.294.698-1.892.597-1.793 1.095-3.387 1.494-4.88a43 43 0 001.096-4.981c-.598.498-1.196.896-1.993 1.394-5.18 3.088-14.045 5.877-21.217 7.172l14.145-1.594-14.145 1.594c-.996.2-1.693.299-2.49.498q.099-.099-47.926 5.067c-.2.2-1.381 2.703-1.88 3.898"
                                                    />
                                                    <path
                                                        fill="url(#g)"
                                                        d="M65.843 350.63c-2.49 6.874-5.08 13.946-7.57 21.118 0 .1-.1.2-.1.299-.399.996-.698 1.992-1.096 3.088-1.693 4.88-3.188 9.164-6.574 19.125 5.578 2.59 10.06 9.264 14.344 16.934-.399-7.87-3.686-15.34-9.961-21.018 27.592 1.195 51.399-5.778 63.651-25.899a51 51 0 002.988-5.678c-5.578 7.073-12.55 10.06-25.5 9.364h-.1.1c19.225-8.567 28.787-16.835 37.354-30.481a170 170 0 005.977-10.659c-16.835 17.233-36.259 22.114-56.679 18.428l-15.34 1.694c-.498 1.095-.996 2.39-1.494 3.685"
                                                    />
                                                </svg>
                                                Apache2
                                            </button> */}
                                        </div>
                                    </div>

                                    <div className={style.category}>
                                        <div className={style.label}>Database</div>
                                        <div className={style.options}>
                                            {/* <button className={style.optionBtn}>
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    aria-hidden="true"
                                                    width={18}
                                                    height={18}
                                                    viewBox="0 0 24 24"
                                                    className="mr-1 iconify iconify--fontisto"
                                                >
                                                    <path
                                                        fill="currentColor"
                                                        d="M24.129 23.412l-.508-.484a6.7 6.7 0 00-.809-.891l-.005-.004q-.448-.407-.931-.774-.387-.266-1.064-.641a1.6 1.6 0 01-.818-.824l-.004-.01-.048-.024c.212-.021.406-.06.592-.115l-.023.006.57-.157c.236-.074.509-.122.792-.133h.006q.446-.02.847-.139l-.025.006q.194-.048.399-.109t.351-.109v-.169q-.145-.217-.351-.496a2.6 2.6 0 00-.443-.468l-.005-.004q-.629-.556-1.303-1.076a16 16 0 00-1.311-.916l-.068-.04a5 5 0 00-.825-.435l-.034-.012q-.448-.182-.883-.399a1.6 1.6 0 00-.327-.119l-.011-.002a.5.5 0 01-.29-.169l-.001-.001a3 3 0 01-.355-.609l-.008-.02q-.145-.339-.314-.651-.363-.702-.702-1.427t-.651-1.452q-.217-.484-.399-.967a5.4 5.4 0 00-.461-.942l.013.023a17 17 0 00-1.331-1.961l.028.038a14.6 14.6 0 00-1.459-1.59l-.008-.007a18 18 0 00-1.632-1.356l-.049-.035q-.896-.651-1.96-1.282a3.7 3.7 0 00-.965-.393l-.026-.006-1.113-.278-.629-.048q-.314-.024-.629-.024a1.7 1.7 0 01-.387-.279 4 4 0 00-.353-.295l-.01-.007a11.7 11.7 0 00-2.043-.93L2.071.18A1.36 1.36 0 00.9.096L.909.093a1.36 1.36 0 00-.795.84l-.003.01a1.52 1.52 0 00.232 1.549l-.002-.003q.544.725.834 1.14.217.291.448.605c.141.188.266.403.367.63l.008.021c.056.119.105.261.141.407l.003.016q.048.206.121.448.217.556.411 1.14c.141.425.297.785.478 1.128l-.019-.04q.145.266.291.52T3.738 9a.9.9 0 00.241.242l.003.002a.4.4 0 01.169.313v.001a1.3 1.3 0 00-.217.586l-.001.006a4 4 0 01-.153.695l.008-.03a7.1 7.1 0 00-.351 2.231q0 .387.04.763l-.003-.031c.06.958.349 1.838.812 2.6l-.014-.025c.197.295.408.552.641.787a.914.914 0 001.106.203l-.005.002a.93.93 0 00.617-.827v-.002c.048-.474.12-.898.219-1.312l-.013.067a.6.6 0 00.038-.211l-.002-.045v.002q-.012-.109.133-.206v.048q.145.339.302.677t.326.677c.295.449.608.841.952 1.202l-.003-.003a7.7 7.7 0 001.127 1.001l.022.015q.316.242.566.528l.004.004q.239.28.56.454l.01.005v-.024h.048a.46.46 0 00-.18-.205l-.002-.001a2 2 0 01-.211-.136l.005.003q-.217-.217-.448-.484t-.423-.508q-.508-.702-.969-1.467t-.871-1.555q-.194-.387-.375-.798t-.351-.798a1 1 0 01-.096-.334v-.005a.32.32 0 00-.168-.265l-.002-.001a3 3 0 01-.408.545l.001-.001a2 2 0 00-.382.58l-.005.013a4.3 4.3 0 00-.289 1.154l-.002.019q-.072.641-.145 1.318l-.048.024-.024.024a.86.86 0 01-.59-.443l-.002-.005q-.182-.351-.326-.69a6.5 6.5 0 01-.423-2.144v-.009a6.2 6.2 0 01.286-2.318l-.012.044q.072-.266.314-.896t.097-.871a.9.9 0 00-.265-.41l-.001-.001a3 3 0 01-.335-.335l-.003-.004q-.169-.244-.326-.52t-.278-.544a11 11 0 01-.474-1.353l-.022-.089a10 10 0 00-.546-1.503l.026.064a3.3 3.3 0 00-.39-.669l.006.008q-.244-.326-.436-.617-.244-.314-.484-.605a3.4 3.4 0 01-.426-.657l-.009-.02a1.6 1.6 0 01-.119-.327l-.002-.011a.4.4 0 01.049-.34l-.001.002a.3.3 0 01.073-.145.3.3 0 01.143-.072h.002a.55.55 0 01.536-.035l-.003-.001c.219.062.396.124.569.195l-.036-.013q.459.194.847.375c.298.142.552.292.792.459l-.018-.012q.194.121.387.266t.411.291h.339q.387 0 .822.037c.293.023.564.078.822.164l-.024-.007c.481.143.894.312 1.286.515l-.041-.019q.593.302 1.125.641c.589.367 1.098.743 1.577 1.154l-.017-.014c.5.428.954.867 1.38 1.331l.01.012c.416.454.813.947 1.176 1.464l.031.047c.334.472.671 1.018.974 1.584l.042.085a5 5 0 01.234.536l.011.033q.097.278.217.57.266.605.57 1.221t.57 1.198l.532 1.161c.187.406.396.756.639 1.079l-.011-.015c.203.217.474.369.778.422l.008.001c.368.092.678.196.978.319l-.047-.017c.143.065.327.134.516.195l.04.011c.212.065.396.151.565.259l-.009-.005c.327.183.604.363.868.559l-.021-.015q.411.302.822.57.194.145.651.423t.484.52a11 11 0 00-1.834.087l.056-.006a6 6 0 00-1.479.39l.04-.014a2.6 2.6 0 01-.388.129l-.019.004a.31.31 0 00-.266.277v.001q.093.115.143.26l.002.006q.05.151.125.272l-.003-.006c.119.211.247.393.391.561l-.004-.005q.212.26.476.454l.007.005q.244.194.508.399c.161.126.343.25.532.362l.024.013c.284.174.614.34.958.479l.046.016c.374.15.695.324.993.531l-.016-.011q.291.169.58.375t.556.399q.11.108.191.239l.003.005a.57.57 0 00.36.193h.003v-.048a.5.5 0 01-.184-.267l-.001-.004a1 1 0 00-.112-.273l.002.004zM5.553 4.207q-.194 0-.363.012a1.3 1.3 0 00-.323.063l.009-.003v.024h.048q.097.145.244.326t.266.351l.387.798.048-.024a.74.74 0 00.252-.321l.002-.005c.052-.139.082-.301.082-.469l-.001-.054v.003a.5.5 0 01-.108-.154l-.001-.003-.081-.182a.5.5 0 00-.214-.192l-.003-.001a1 1 0 01-.244-.169"
                                                    />
                                                </svg>  MySQL
                                            </button> */}
                                            <button className={`${style.optionBtn} ${style.active}`}>
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    aria-hidden="true"
                                                    width={18}
                                                    height={18}
                                                    viewBox="0 0 24 24"
                                                    className="mr-1 iconify iconify--simple-icons"
                                                >
                                                    <path
                                                        fill="currentColor"
                                                        d="M23.157 4.412c-.676.284-.79.31-1.673.372-.65.045-.757.057-1.212.209-.75.246-1.395.75-2.02 1.59-.296.398-1.249 1.913-1.249 1.988 0 .057-.65.998-.915 1.32-.574.713-1.08 1.079-2.14 1.59-.77.36-1.224.524-4.102 1.477-1.073.353-2.133.738-2.367.864-.852.449-1.515 1.036-2.203 1.938-1.003 1.32-.972 1.313-3.042.947a12 12 0 00-.675-.063c-.644-.05-1.023.044-1.332.334L0 17.193l.177.088c.094.05.353.234.561.398.215.17.461.347.55.391.088.044.17.088.183.101s-.089.17-.228.353c-.435.581-.593.871-.574 1.048.019.164.032.17.43.17.517-.006.826-.056 1.261-.208.65-.233 2.058-.94 2.784-1.4.776-.5 1.717-.998 1.956-1.042.082-.02.354-.07.594-.114.58-.107 1.464-.095 2.587.05.108.013.373.045.6.064.227.025.43.057.454.076.026.012.474.037.998.056.934.026 1.104.007 1.3-.189.126-.133.385-.631.498-.985.209-.643.417-.921.366-.492-.113.966-.322 1.692-.713 2.411-.259.499-.663 1.092-.934 1.395-.322.347-.315.36.088.315.619-.063 1.471-.397 2.096-.82.827-.562 1.647-1.691 2.19-3.03.107-.27.22-.22.183.083-.013.094-.038.315-.057.498l-.031.328.353-.202c.833-.48 1.414-1.262 2.127-2.884.227-.518.877-2.922 1.073-3.976a10 10 0 01.271-1.042c.127-.429.196-.555.48-.858.183-.19.625-.555.978-.808.72-.505.953-.75 1.187-1.205.208-.417.284-1.13.132-1.357-.132-.202-.284-.196-.763.006"
                                                    />
                                                </svg> MariaDB 11.4
                                            </button>
                                            {/* <button className={style.optionBtn}>
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    aria-hidden="true"
                                                    width={8.4}
                                                    height={18}
                                                    viewBox="0 0 256 549"
                                                    className="mr-1 iconify iconify--logos"
                                                >
                                                    <path
                                                        fill="#01EC64"
                                                        d="M175.622 61.108C152.612 33.807 132.797 6.078 128.749.32a1.03 1.03 0 00-1.492 0c-4.048 5.759-23.863 33.487-46.874 60.788-197.507 251.896 31.108 421.89 31.108 421.89l1.917 1.28c1.704 26.234 5.966 63.988 5.966 63.988h17.045s4.26-37.54 5.965-63.987l1.918-1.494c.213.214 228.828-169.78 31.32-421.677m-47.726 418.05s-10.227-8.744-12.997-13.222v-.428l12.358-274.292c0-.853 1.279-.853 1.279 0l12.357 274.292v.428c-2.77 4.478-12.997 13.223-12.997 13.223"
                                                    />
                                                </svg>    MongoDB
                                            </button>
                                            <button className={style.optionBtn}>
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    aria-hidden="true"
                                                    width={17.46}
                                                    height={18}
                                                    viewBox="0 0 256 264"
                                                    className="mr-1 iconify iconify--logos"
                                                >
                                                    <path d="M255.008 158.086c-1.535-4.649-5.556-7.887-10.756-8.664-2.452-.366-5.26-.21-8.583.475-5.792 1.195-10.089 1.65-13.225 1.738 11.837-19.985 21.462-42.775 27.003-64.228 8.96-34.689 4.172-50.492-1.423-57.64C233.217 10.847 211.614.683 185.552.372c-13.903-.17-26.108 2.575-32.475 4.549-5.928-1.046-12.302-1.63-18.99-1.738-12.537-.2-23.614 2.533-33.079 8.15-5.24-1.772-13.65-4.27-23.362-5.864-22.842-3.75-41.252-.828-54.718 8.685C6.622 25.672-.937 45.684.461 73.634c.444 8.874 5.408 35.874 13.224 61.48 4.492 14.718 9.282 26.94 14.237 36.33 7.027 13.315 14.546 21.156 22.987 23.972 4.731 1.576 13.327 2.68 22.368-4.85 1.146 1.388 2.675 2.767 4.704 4.048 2.577 1.625 5.728 2.953 8.875 3.74 11.341 2.835 21.964 2.126 31.027-1.848.056 1.612.099 3.152.135 4.482.06 2.157.12 4.272.199 6.25.537 13.374 1.447 23.773 4.143 31.049.148.4.347 1.01.557 1.657 1.345 4.118 3.594 11.012 9.316 16.411 5.925 5.593 13.092 7.308 19.656 7.308 3.292 0 6.433-.432 9.188-1.022 9.82-2.105 20.973-5.311 29.041-16.799 7.628-10.86 11.336-27.217 12.007-52.99q.13-1.094.244-2.088l.16-1.362 1.797.158.463.031c10.002.456 22.232-1.665 29.743-5.154 5.935-2.754 24.954-12.795 20.476-26.351" />
                                                    <path
                                                        fill="#336791"
                                                        d="M237.906 160.722c-29.74 6.135-31.785-3.934-31.785-3.934 31.4-46.593 44.527-105.736 33.2-120.211-30.904-39.485-84.399-20.811-85.292-20.327l-.287.052c-5.876-1.22-12.451-1.946-19.842-2.067-13.456-.22-23.664 3.528-31.41 9.402 0 0-95.43-39.314-90.991 49.444.944 18.882 27.064 142.873 58.218 105.422 11.387-13.695 22.39-25.274 22.39-25.274 5.464 3.63 12.006 5.482 18.864 4.817l.533-.452c-.166 1.7-.09 3.363.213 5.332-8.026 8.967-5.667 10.541-21.711 13.844-16.235 3.346-6.698 9.302-.471 10.86 7.549 1.887 25.013 4.561 36.813-11.958l-.47 1.885c3.144 2.519 5.352 16.383 4.982 28.952-.37 12.568-.617 21.197 1.86 27.937 2.479 6.74 4.948 21.905 26.04 17.386 17.623-3.777 26.756-13.564 28.027-29.89.901-11.606 2.942-9.89 3.07-20.267l1.637-4.912c1.887-15.733.3-20.809 11.157-18.448l2.64.232c7.99.363 18.45-1.286 24.589-4.139 13.218-6.134 21.058-16.377 8.024-13.686z"
                                                    />
                                                    <path
                                                        fill="#FFF"
                                                        d="M108.076 81.525c-2.68-.373-5.107-.028-6.335.902-.69.523-.904 1.129-.962 1.546-.154 1.105.62 2.327 1.096 2.957 1.346 1.784 3.312 3.01 5.258 3.28q.423.059.842.058c3.245 0 6.196-2.527 6.456-4.392.325-2.336-3.066-3.893-6.355-4.35m88.784.073c-.256-1.831-3.514-2.353-6.606-1.923-3.088.43-6.082 1.824-5.832 3.659.2 1.427 2.777 3.863 5.827 3.863q.387 0 .78-.054c2.036-.282 3.53-1.575 4.24-2.32 1.08-1.136 1.706-2.402 1.591-3.225"
                                                    />
                                                    <path
                                                        fill="#FFF"
                                                        d="M247.802 160.025c-1.134-3.429-4.784-4.532-10.848-3.28-18.005 3.716-24.453 1.142-26.57-.417 13.995-21.32 25.508-47.092 31.719-71.137 2.942-11.39 4.567-21.968 4.7-30.59.147-9.463-1.465-16.417-4.789-20.665-13.402-17.125-33.072-26.311-56.882-26.563-16.369-.184-30.199 4.005-32.88 5.183-5.646-1.404-11.801-2.266-18.502-2.376-12.288-.199-22.91 2.743-31.704 8.74-3.82-1.422-13.692-4.811-25.765-6.756-20.872-3.36-37.458-.814-49.294 7.571-14.123 10.006-20.643 27.892-19.38 53.16.425 8.501 5.269 34.653 12.913 59.698 10.062 32.964 21 51.625 32.508 55.464 1.347.449 2.9.763 4.613.763 4.198 0 9.345-1.892 14.7-8.33a530 530 0 0120.261-22.926c4.524 2.428 9.494 3.784 14.577 3.92q.016.2.035.398a118 118 0 00-2.57 3.175c-3.522 4.471-4.255 5.402-15.592 7.736-3.225.666-11.79 2.431-11.916 8.435-.136 6.56 10.125 9.315 11.294 9.607 4.074 1.02 7.999 1.523 11.742 1.523 9.103 0 17.114-2.992 23.516-8.781-.197 23.386.778 46.43 3.586 53.451 2.3 5.748 7.918 19.795 25.664 19.794 2.604 0 5.47-.303 8.623-.979 18.521-3.97 26.564-12.156 29.675-30.203 1.665-9.645 4.522-32.676 5.866-45.03 2.836.885 6.487 1.29 10.434 1.289 8.232 0 17.731-1.749 23.688-4.514 6.692-3.108 18.768-10.734 16.578-17.36m-44.106-83.48c-.061 3.647-.563 6.958-1.095 10.414-.573 3.717-1.165 7.56-1.314 12.225-.147 4.54.42 9.26.968 13.825 1.108 9.22 2.245 18.712-2.156 28.078a37 37 0 01-1.95-4.009c-.547-1.326-1.735-3.456-3.38-6.404-6.399-11.476-21.384-38.35-13.713-49.316 2.285-3.264 8.084-6.62 22.64-4.813m-17.644-61.787c21.334.471 38.21 8.452 50.158 23.72 9.164 11.711-.927 64.998-30.14 110.969a171 171 0 00-.886-1.117l-.37-.462c7.549-12.467 6.073-24.802 4.759-35.738-.54-4.488-1.05-8.727-.92-12.709.134-4.22.692-7.84 1.232-11.34.663-4.313 1.338-8.776 1.152-14.037.139-.552.195-1.204.122-1.978-.475-5.045-6.235-20.144-17.975-33.81-6.422-7.475-15.787-15.84-28.574-21.482 5.5-1.14 13.021-2.203 21.442-2.016M66.674 175.778c-5.9 7.094-9.974 5.734-11.314 5.288-8.73-2.912-18.86-21.364-27.791-50.624-7.728-25.318-12.244-50.777-12.602-57.916-1.128-22.578 4.345-38.313 16.268-46.769 19.404-13.76 51.306-5.524 64.125-1.347-.184.182-.376.352-.558.537-21.036 21.244-20.537 57.54-20.485 59.759-.002.856.07 2.068.168 3.735.362 6.105 1.036 17.467-.764 30.334-1.672 11.957 2.014 23.66 10.111 32.109a36 36 0 002.617 2.468c-3.604 3.86-11.437 12.396-19.775 22.426m22.479-29.993c-6.526-6.81-9.49-16.282-8.133-25.99 1.9-13.592 1.199-25.43.822-31.79-.053-.89-.1-1.67-.127-2.285 3.073-2.725 17.314-10.355 27.47-8.028 4.634 1.061 7.458 4.217 8.632 9.645 6.076 28.103.804 39.816-3.432 49.229-.873 1.939-1.698 3.772-2.402 5.668l-.546 1.466c-1.382 3.706-2.668 7.152-3.465 10.424-6.938-.02-13.687-2.984-18.819-8.34m1.065 37.9c-2.026-.506-3.848-1.385-4.917-2.114.893-.42 2.482-.992 5.238-1.56 13.337-2.745 15.397-4.683 19.895-10.394 1.031-1.31 2.2-2.794 3.819-4.602l.002-.002c2.411-2.7 3.514-2.242 5.514-1.412 1.621.67 3.2 2.702 3.84 4.938.303 1.056.643 3.06-.47 4.62-9.396 13.156-23.088 12.987-32.921 10.526m69.799 64.952c-16.316 3.496-22.093-4.829-25.9-14.346-2.457-6.144-3.665-33.85-2.808-64.447.011-.407-.047-.8-.159-1.17a15.4 15.4 0 00-.456-2.162c-1.274-4.452-4.379-8.176-8.104-9.72-1.48-.613-4.196-1.738-7.46-.903.696-2.868 1.903-6.107 3.212-9.614l.549-1.475c.618-1.663 1.394-3.386 2.214-5.21 4.433-9.848 10.504-23.337 3.915-53.81-2.468-11.414-10.71-16.988-23.204-15.693-7.49.775-14.343 3.797-17.761 5.53-.735.372-1.407.732-2.035 1.082.954-11.5 4.558-32.992 18.04-46.59 8.489-8.56 19.794-12.788 33.568-12.56 27.14.444 44.544 14.372 54.366 25.979 8.464 10.001 13.047 20.076 14.876 25.51-13.755-1.399-23.11 1.316-27.852 8.096-10.317 14.748 5.644 43.372 13.315 57.129 1.407 2.521 2.621 4.7 3.003 5.626 2.498 6.054 5.732 10.096 8.093 13.046.724.904 1.426 1.781 1.96 2.547-4.166 1.201-11.649 3.976-10.967 17.847-.55 6.96-4.461 39.546-6.448 51.059-2.623 15.21-8.22 20.875-23.957 24.25m68.104-77.936c-4.26 1.977-11.389 3.46-18.161 3.779-7.48.35-11.288-.838-12.184-1.569-.42-8.644 2.797-9.547 6.202-10.503.535-.15 1.057-.297 1.561-.473q.469.383 1.032.756c6.012 3.968 16.735 4.396 31.874 1.271l.166-.033c-2.042 1.909-5.536 4.471-10.49 6.772"
                                                    />
                                                </svg>
                                                PostgreSQL
                                            </button> */}
                                        </div>
                                    </div>

                                    <div className={style.category}>
                                        <div className={style.label}>App</div>
                                        <div className={style.options}>
                                            <button className={`${style.optionBtn} ${style.active}`}>
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    aria-hidden="true"
                                                    width={34.14}
                                                    height={18}
                                                    viewBox="0 0 256 135"
                                                    className="mr-1 iconify iconify--logos"
                                                >
                                                    <defs>
                                                        <radialGradient
                                                            id="a"
                                                            cx={0.837}
                                                            cy={-125.811}
                                                            r={363.057}
                                                            gradientTransform="matrix(.463 0 0 .463 76.464 81.918)"
                                                            gradientUnits="userSpaceOnUse"
                                                        >
                                                            <stop offset={0} stopColor="#FFF" />
                                                            <stop offset={0.5} stopColor="#4C6B97" />
                                                            <stop offset={1} stopColor="#231F20" />
                                                        </radialGradient>
                                                    </defs>
                                                    <ellipse cx={128} cy={67.3} fill="url(#a)" rx={128} ry={67.3} />
                                                    <ellipse cx={128} cy={67.3} fill="#6181B6" rx={123} ry={62.3} />
                                                    <path
                                                        fill="#FFF"
                                                        d="M152.9 87.5l6.1-31.4c1.4-7.1.2-12.4-3.4-15.7-3.5-3.2-9.5-4.8-18.3-4.8h-10.6l3-15.6c.1-.6 0-1.2-.4-1.7s-.9-.7-1.5-.7h-14.6c-1 0-1.8.7-2 1.6l-6.5 33.3c-.6-3.8-2-7-4.4-9.6-4.3-4.9-11-7.4-20.1-7.4H52.1c-1 0-1.8.7-2 1.6L37 104.7c-.1.6 0 1.2.4 1.7s.9.7 1.5.7h14.7c1 0 1.8-.7 2-1.6l3.2-16.3h10.9c5.7 0 10.6-.6 14.3-1.8q5.85-1.95 10.5-6.3c2.5-2.3 4.6-4.9 6.2-7.7l-2.6 13.5c-.1.6 0 1.2.4 1.7s.9.7 1.5.7h14.6c1 0 1.8-.7 2-1.6l7.2-37h10c4.3 0 5.5.8 5.9 1.2.3.3.9 1.5.2 5.2L134.1 87c-.1.6 0 1.2.4 1.7s.9.7 1.5.7h15c.9-.3 1.7-1 1.9-1.9m-67.6-26c-.9 4.7-2.6 8.1-5.1 10s-6.6 2.9-12 2.9h-6.5l4.7-24.2h8.4c6.2 0 8.7 1.3 9.7 2.4 1.3 1.6 1.6 4.7.8 8.9m130-18.6c-4.3-4.9-11-7.4-20.1-7.4h-28.3c-1 0-1.8.7-2 1.6l-13.1 67.5c-.1.6 0 1.2.4 1.7s.9.7 1.5.7h14.7c1 0 1.8-.7 2-1.6l3.2-16.3h10.9c5.7 0 10.6-.6 14.3-1.8q5.85-1.95 10.5-6.3c2.6-2.4 4.8-5.1 6.4-8s2.8-6.1 3.5-9.6c1.7-8.7.4-15.5-3.9-20.5M200 61.5c-.9 4.7-2.6 8.1-5.1 10s-6.6 2.9-12 2.9h-6.5l4.7-24.2h8.4c6.2 0 8.7 1.3 9.7 2.4 1.4 1.6 1.7 4.7.8 8.9"
                                                    />
                                                    <path
                                                        fill="#000004"
                                                        d="M74.8 48.2c5.6 0 9.3 1 11.2 3.1s2.3 5.6 1.3 10.6c-1 5.2-3 9-5.9 11.2q-4.35 3.3-13.2 3.3h-8.9l5.5-28.2zM39 105h14.7l3.5-17.9h12.6c5.6 0 10.1-.6 13.7-1.8s6.8-3.1 9.8-5.9q3.75-3.45 6-7.5c1.5-2.7 2.6-5.7 3.2-9 1.6-8 .4-14.2-3.5-18.7s-10.1-6.7-18.6-6.7H52.1zm74.3-85.4h14.6l-3.5 17.9h13c8.2 0 13.8 1.4 16.9 4.3s4 7.5 2.8 13.9L151 87.1h-14.8l5.8-29.9c.7-3.4.4-5.7-.7-6.9s-3.6-1.9-7.3-1.9h-11.7l-7.5 38.7h-14.6zm76.2 28.6c5.6 0 9.3 1 11.2 3.1s2.3 5.6 1.3 10.6c-1 5.2-3 9-5.9 11.2q-4.35 3.3-13.2 3.3H174l5.5-28.2zM153.7 105h14.7l3.5-17.9h12.6c5.6 0 10.1-.6 13.7-1.8s6.8-3.1 9.8-5.9q3.75-3.45 6-7.5c1.5-2.7 2.6-5.7 3.2-9 1.6-8 .4-14.2-3.5-18.7s-10.1-6.7-18.6-6.7h-28.3z"
                                                    />
                                                </svg>      PHP 8.3
                                            </button>
                                            {/* <button className={style.optionBtn}>
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    aria-hidden="true"
                                                    width={15.95}
                                                    height={18}
                                                    viewBox="0 0 256 289"
                                                    className="mr-1 iconify iconify--logos"
                                                >
                                                    <path
                                                        fill="#539E43"
                                                        d="M128 288.464c-3.975 0-7.685-1.06-11.13-2.915l-35.247-20.936c-5.3-2.915-2.65-3.975-1.06-4.505 7.155-2.385 8.48-2.915 15.9-7.156.796-.53 1.856-.265 2.65.265l27.032 16.166c1.06.53 2.385.53 3.18 0l105.74-61.217c1.06-.53 1.59-1.59 1.59-2.915V83.08c0-1.325-.53-2.385-1.59-2.915l-105.74-60.953c-1.06-.53-2.385-.53-3.18 0L20.405 80.166c-1.06.53-1.59 1.855-1.59 2.915v122.17c0 1.06.53 2.385 1.59 2.915l28.887 16.695c15.636 7.95 25.44-1.325 25.44-10.6V93.68c0-1.59 1.326-3.18 3.181-3.18h13.516c1.59 0 3.18 1.325 3.18 3.18v120.58c0 20.936-11.396 33.126-31.272 33.126-6.095 0-10.865 0-24.38-6.625l-27.827-15.9C4.24 220.885 0 213.465 0 205.515V83.346C0 75.396 4.24 67.976 11.13 64L116.87 2.783c6.625-3.71 15.635-3.71 22.26 0L244.87 64C251.76 67.975 256 75.395 256 83.346v122.17c0 7.95-4.24 15.37-11.13 19.345L139.13 286.08c-3.445 1.59-7.42 2.385-11.13 2.385m32.596-84.009c-46.377 0-55.917-21.2-55.917-39.221 0-1.59 1.325-3.18 3.18-3.18h13.78c1.59 0 2.916 1.06 2.916 2.65 2.12 14.045 8.215 20.936 36.306 20.936 22.261 0 31.802-5.035 31.802-16.96 0-6.891-2.65-11.926-37.367-15.372-28.886-2.915-46.907-9.275-46.907-32.33 0-21.467 18.02-34.187 48.232-34.187 33.921 0 50.617 11.66 52.737 37.101q0 1.193-.795 2.385c-.53.53-1.325 1.06-2.12 1.06h-13.78c-1.326 0-2.65-1.06-2.916-2.385-3.18-14.575-11.395-19.345-33.126-19.345-24.38 0-27.296 8.48-27.296 14.84 0 7.686 3.445 10.07 36.306 14.31 32.597 4.24 47.967 10.336 47.967 33.127-.265 23.321-19.345 36.571-53.002 36.571"
                                                    />
                                                </svg>    NodeJS
                                            </button> */}
                                        </div>
                                    </div>
                                    {/* <div className={style.label}>Version PHP</div>
                                    <div className={style.optionsinput}>
                                        {["8.4", "8.3", "8.2", "8.1", "8.0", "7.4", "7.3", "7.2", "7.1", "7.0", "5.6"].map((version, index) => (
                                            <label key={index}>
                                                <input disabled type="radio" name="php_version" defaultChecked={version === "8.3"} /> {version}
                                            </label>
                                        ))}
                                    </div>
                                    <div className={style.label}>Version MariaDB</div>
                                    <div className={style.optionsinput}>
                                        {["11.rc", "11.rolling", "11.8", "11.7", "11.4", "10.11", "10.6", "10.5"].map((version, index) => (
                                            <label key={index}>
                                                <input disabled type="radio" name="mariadb_version" defaultChecked={version === "11.rc"} /> {version}
                                            </label>
                                        ))}
                                    </div> */}
                                </div>
                                {/* 
                                <div className={style.section}>
                                    <div className={style.tiltleframe}>
                                        <h6>Coupon</h6>
                                    </div>
                                    <Discount getPriceDiscount={handleXuLyGiaKhuyenMai} />
                                </div>

                                <div className={style.section}>
                                    <div className={style.tiltleframe}>
                                        <h6>Choose Payment Method                                        </h6>
                                    </div>
                                    <PaymentOptions onStatusChange={handleStatusChange} />
                                </div> */}
                                {/* <div className={style.section}>
                                    <h5>Choose Payment*</h5>
                                    <PaymentOptions OnSelectedOption={handleStatusChange}
                                    />
                                </div> */}

                            </div>
                        </div>
                    </div>

                    {/* Right Section */}
                    <div className="col-12 col-lg-2 d-flex justify-content-end me-auto">
                        <div className="w-100">
                            <InvoiceCSHP
                                onChildError={handleChildError} // Truyền hàm xử lý lỗi xuống con
                                packages={packages}
                                baseAmount={baseAmount}
                                totalAmount={totalAmount}
                                selectedproduct={serverchose}
                                selectedpackage={packages}
                                selectedCycle={circleChose}
                                selectedChildSystem={selectedChildSystem}
                                selectednameversion={selectednameversion}
                                selectedFeatures={selectedFeatures}
                                taxAmount={taxAmount}
                                pricekm={pricekm}
                                isChecked={isChecked}
                                // backup={backup}
                                backupPrice={backupPrice}
                                backupselected={pricebackup?.isSelected}
                                pricebackup={pricebackup?.price}

                                postdiscount={postdiscount}
                                // pricepermonth={pricepermonth}
                                regions={selectedRegion}
                                // priceAdd={priceAdd}
                                hostname={hostname}
                                backup={pricebackup}

                            />
                        </div>
                    </div>



                </div>

            </div>

        </>
    );
});

export default ParentPanel; 